module.exports = __webpack_public_path__ + "static/media/toasty.81fca554.png";